import { useState } from "react";
import { Link } from "react-router-dom";
import IconLink from "../common/IconLink";
import PDFViewerModal from "../common/PDFViewerModal";

// Assets
import advisoryPhoto from "../../assets/images/compressed-images/purple-office-1.jpg";
import buildPhoto from "../../assets/images/compressed-images/purple-office-2.jpg";
import buildXPhoto from "../../assets/images/compressed-images/image_20260220_163343.jpg";
import aiPhoto from "../../assets/images/compressed-images/ai_image.jpg";

// Icons
import { ArrowRightIcon } from "@heroicons/react/24/solid";

const RAVLOfferings = () => {
  const [isPDFOpen, setIsPDFOpen] = useState(false);

  return (
    <>
      <section
        id="RAVL-Offerings"
        className="flex flex-col items-center gap-6 md:gap-11 p-4 md:p-8 pt-20 md:pt-[88px]"
      >
        <div className="flex flex-col items-center gap-4 text-center w-full max-w-xl">
          <h2 className="text-4xl font-bold leading-[1.15] text-black sm:text-6xl sm:leading-[1.15]">
            What We Do
          </h2>
          <h3 className="text-gray-700 sm:text-xl">
            Our mission is to be a true partner to our clients by{" "}
            <span className="text-purple-700 font-semibold">
              building better technology that drives meaningful, long-lasting
              business outcomes.
            </span>
          </h3>
        </div>
        <div className="flex flex-col items-center gap-6 max-w-6xl">
          <div className="flex flex-col-reverse lg:grid lg:grid-cols-2 gap-4 md:gap-6">
            <div className="card flex flex-col p-8 gap-4 justify-between lg:text-left w-full h-auto">
              <div className="flex flex-col gap-5 lg:text-left w-full">
                <h3 className="capitalize text-purple-700 text-3xl font-bold">
                  Advise
                </h3>
                <h4 className="text-2xl font-bold">Strategize and Solution</h4>
                <p>
                  Strategy should spark momentum, not stall in slide decks. We
                  combine deep FSI fluency and business insight with engineering
                  expertise to deliver solutions that are built for real-world
                  execution.
                </p>
                <h5 className="text-xl font-bold pb-1 border-b border-purple-700">
                  {" "}
                  Our core capabilities include:
                </h5>
                <div className="grid grid-cols-1 md:gap-4 md:grid-cols-2">
                  <ul className="flex flex-col gap-[2px]">
                    <li>Architecture</li>
                    <li>Bus. & tech capability mapping</li>
                    <li>Business casing</li>
                    <li>Cost Optimization</li>
                    <li>Customer journey mapping</li>
                    <li>Governance</li>
                  </ul>
                  <ul className="flex flex-col gap-[2px]">
                    <li>Operating models</li>
                    <li>Process improvement/automation</li>
                    <li>Technical assessments/root cause analysis</li>
                    <li>Technology selection</li>
                    <li>Technology strategy & roadmaps</li>
                  </ul>
                </div>
              </div>
              <IconLink
                link="/services/advisory"
                text="Explore Advisory"
                icon={<ArrowRightIcon className="h-4" />}
              />
            </div>
            <div className="card flex w-full h-auto">
              <img
                src={advisoryPhoto}
                alt="people"
                className="shadow-lg rounded-lg w-full h-auto object-cover"
              />
            </div>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-6">
            <div className="card flex w-full h-auto">
              <img
                src={buildPhoto}
                alt="people"
                className="shadow-lg rounded-lg w-full h-auto object-cover"
              />
            </div>
            <div className="card flex flex-col p-8 gap-4 justify-between lg:text-left w-full h-auto">
              <div className="flex flex-col gap-5 lg:text-left w-full">
                <h3 className="capitalize text-purple-700 text-3xl font-bold">
                  Build
                </h3>
                <h4 className="text-2xl font-bold">Engineer & Deliver</h4>
                <p>
                  How you build is just as critical as what you build. Our team
                  specializes in industry-relevant technologies and modern
                  engineering best practices to build resilient, secure, and
                  scalable solutions.
                </p>
                <h5 className="text-xl font-bold pb-1 border-b border-purple-700">
                  {" "}
                  Our expertise lies in:
                </h5>
                <div className="grid grid-cols-1 md:gap-4 md:grid-cols-2">
                  <ul className="flex flex-col gap-[2px]">
                    <li>Solutions Architecture</li>
                    <li>Cloud Engineering</li>
                    <li>DevSecOps</li>
                    <li>Platform Engineering</li>
                  </ul>
                  <ul className="flex flex-col gap-[2px]">
                    <li>Site Reliability Engineering</li>
                    <li>Application Development</li>
                    <li>AI & Machine Learning</li>
                    <li>Infrastructure as Code</li>
                  </ul>
                </div>
              </div>
              <IconLink
                link="/services/build"
                text="Explore Build"
                icon={<ArrowRightIcon className="h-4" />}
              />
            </div>
          </div>
          <div className="flex flex-col-reverse lg:grid lg:grid-cols-2 gap-4 md:gap-6">
            <div className="card flex flex-col p-8 gap-4 justify-between lg:text-left w-full h-auto">
              <div className="flex flex-col gap-5 lg:text-left w-full">
                <h3 className="capitalize text-purple-700 text-3xl font-bold">
                  BuildX
                </h3>
                <h4 className="text-2xl font-bold">
                  Sustain. Upskill. Empower.
                </h4>
                <p>
                  Through our BuildX offering, we deliver top-tier technology
                  solutions where our clients have the option to hire a subset
                  of the team giving you the ability to continue the journey.
                </p>
                <h5 className="text-xl font-bold pb-1 border-b border-purple-700">
                  {" "}
                  BuildX combines the best of:
                </h5>
                <div className="grid grid-cols-1 md:gap-4 md:grid-cols-2">
                  <ul className="flex flex-col gap-[2px]">
                    <li>Outcome based delivery</li>
                    <li>Cloud & Platform Engineering</li>
                    <li>Software Engineering</li>
                  </ul>
                  <ul className="flex flex-col gap-[2px]">
                    <li>Mentorship</li>
                    <li>Hands On Learning Journeys</li>
                  </ul>
                </div>
              </div>
              <IconLink
                link="/services/build#how-we-like-to-build"
                text="Explore BuildX"
                icon={<ArrowRightIcon className="h-4" />}
              />
            </div>
            <div className="card flex w-full h-auto">
              <img
                src={buildXPhoto}
                alt="people"
                className="shadow-lg rounded-lg w-full h-auto object-cover"
              />
            </div>
          </div>

          <div className="flex flex-col-reverse lg:grid lg:grid-cols-2 gap-4 md:gap-6">
            <div className="card flex w-full h-auto">
              <img
                src={aiPhoto}
                alt="people"
                className="shadow-lg rounded-lg w-full h-full object-cover object-left"
              />
            </div>
            <div className="card flex flex-col p-8 gap-4 justify-between lg:text-left w-full h-auto">
              <div className="flex flex-col gap-5 lg:text-left w-full">
                <h3 className="capitalize text-purple-700 text-3xl font-bold">
                  AI
                </h3>
                <h4 className="text-2xl font-bold">
                  AI accelerates delivery. Leap Left redesigns it.
                </h4>
                <p>
                  Software teams are entering a new era where the biggest
                  constraint is no longer writing code, but everything
                  surrounding it. Leap Left introduces RAVL’s approach to
                  AI-first SDLC: aligning people, workflows, governance, and
                  engineering systems to unlock faster, higher-quality delivery
                  at scale.
                </p>
              </div>
              <button
                onClick={() => setIsPDFOpen(true)}
                className="btn-primary mt-12 flex items-center justify-center shadow-md text-base w-3/4 md:w-60 gap-4"
              >
                Read more
                <span className="ml-2">
                  <ArrowRightIcon className="h-4" />
                </span>
              </button>
            </div>
          </div>
        </div>
      </section>
      <PDFViewerModal
        isOpen={isPDFOpen}
        closeModal={() => setIsPDFOpen(false)}
      />
    </>
  );
};

export default RAVLOfferings;
